import React from "react";
import { Form, FormControl, Row, Col } from "react-bootstrap";

/**
 * FileUpload Component
 * Handles file upload with preview and removal
 * Memoized to prevent unnecessary re-renders
 * 
 * @param {Object} props
 * @param {Object} props.file - File object with base64, fileName, fileExtension
 * @param {boolean} props.hasFile - Whether a file is uploaded
 * @param {Function} props.handleFileRead - File change handler
 * @param {Function} props.removeFile - Remove file handler
 */
const FileUpload = React.memo(({
  file,
  hasFile,
  handleFileRead,
  removeFile,
}) => {
  return (
    <Form.Group controlId="file">
      <Form.Label>Upload file</Form.Label>
      {hasFile && (
        <Row className="bg-light">
          <Col
            xs={10}
            className="fw-bolder my-auto d-flex align-items-center rounded-start shadow"
            style={{
              paddingLeft: "20px",
              paddingTop: "10px",
              paddingBottom: "10px",
            }}
          >
            <span className="ms-2">{file.fileName}</span>
          </Col>
          <Col
            xs={2}
            className="d-flex align-items-center justify-content-center"
            style={{
              cursor: "pointer",
            }}
            onClick={removeFile}
          >
            <i className="far fa-window-close fa-2x"></i>
          </Col>
        </Row>
      )}
      <FormControl type="file" name="file" onChange={handleFileRead} />
    </Form.Group>
  );
});

FileUpload.displayName = "FileUpload";

export default FileUpload;
